import { render, staticRenderFns } from "./ExtraContent.vue?vue&type=template&id=9bda3442&scoped=true"
import script from "./ExtraContent.vue?vue&type=script&lang=js"
export * from "./ExtraContent.vue?vue&type=script&lang=js"
import style0 from "./ExtraContent.vue?vue&type=style&index=0&id=9bda3442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bda3442",
  null
  
)

export default component.exports